import { enableProdMode } from '@angular/core';
import { AppRoot } from './app/app.component';
import { environment, ServiceProvider } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, Routes, withDebugTracing } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { GoogleMapService } from './app/Components/google-map/google-map.service';
import { StateService } from './app/Service/state-service.service';

if (environment.production) {
  enableProdMode();
}

export function serviceFactory(svc: ServiceProvider) {
  return svc.getService();
}

const appRoutes: Routes = [
  { path: 'businspection', redirectTo: '', pathMatch: 'full' },
  { path: '', component: AppRoot },
  { path: '**', redirectTo: 'businspection' }
];

bootstrapApplication(AppRoot, {
  providers: [
    provideRouter(appRoutes, withDebugTracing()),
    GoogleMapService,
    ServiceProvider,
    {
      provide: StateService,
      useFactory: serviceFactory,
      deps: [ServiceProvider]
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
}).catch((e) => console.error(e));
